var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mr-2"},[_c('v-select',{staticClass:"mt-0",staticStyle:{"width":"87px","z-index":"10"},attrs:{"dense":"","solo":"","items":_vm.items,"value":_vm.playbackRate,"hide-details":true,"disabled":_vm.presentationDisabled},on:{"input":function($event){return _vm.changePlaybackRate($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }